import { Check } from "lucide-react";
import { ExtLink } from "@/components/Ui";
import { INVESTMENT, MARKET, SUPPORT } from "@/content/site";

export const Pillars = ({ items, testId, dark = false }) => (
  <ul className={`grid gap-px sm:grid-cols-2 ${dark ? "bg-ivory/15" : "bg-line"}`} data-testid={testId}>
    {items.map((p, i) => (
      <li key={p.title} className={`p-7 md:p-9 ${dark ? "bg-ink" : "bg-white"}`}>
        <p className={`font-display text-sm font-semibold ${dark ? "text-gold" : "text-gold-deep"}`} aria-hidden="true">{String(i + 1).padStart(2, "0")}</p>
        <h3 className={`mt-4 text-xl font-semibold md:text-2xl ${dark ? "text-ivory" : ""}`}>{p.title}</h3>
        <p className={`mt-3 ${dark ? "text-stone-300" : "text-stone-600"}`}>{p.text}</p>
      </li>
    ))}
  </ul>
);

export const SupportList = () => (
  <ul className="grid gap-x-10 sm:grid-cols-2" data-testid="support-list">
    {SUPPORT.items.map((s) => (
      <li key={s} className="flex gap-3 border-b border-line py-4">
        <Check aria-hidden="true" className="mt-1 h-5 w-5 shrink-0 text-gold-deep" />
        <span>{s}</span>
      </li>
    ))}
  </ul>
);

export const MarketGrowth = ({ headingLevel: H = "h2" }) => (
  <div>
    <H className="h2">{MARKET.growthTitle}</H>
    <ul className="mt-10 grid gap-px bg-line sm:grid-cols-2 lg:grid-cols-3" data-testid="market-growth-list">
      {MARKET.stats.map((s) => (
        <li key={s.id} className="flex flex-col bg-white p-7" data-testid={`market-stat-${s.id}`}>
          <p className="font-display text-2xl font-bold text-ink md:text-3xl" aria-hidden="true">{s.link}</p>
          <h3 className="mt-4 font-display text-xs font-semibold uppercase tracking-[0.18em] text-gold-deep">{s.category}</h3>
          <p className="mt-2 flex-1 text-stone-600">
            <strong className="font-semibold text-ink">{s.category}:</strong> {s.before}
            <ExtLink href={s.href} testId={`market-stat-link-${s.id}`}>{s.link}</ExtLink>{s.after}
          </p>
          <p className="mt-5 text-xs text-stone-600">Source: <ExtLink href={s.href} className="underline" testId={`market-source-${s.id}`}>{s.source}</ExtLink></p>
        </li>
      ))}
    </ul>
  </div>
);

export const InvestmentSnapshot = ({ headingLevel: H = "h2" }) => (
  <div>
    <p className="eyebrow mb-5">{INVESTMENT.eyebrow}</p>
    <H className="h2 text-ivory">{INVESTMENT.title}</H>
    <dl className="mt-10 grid gap-px bg-ivory/15 md:grid-cols-3" data-testid="investment-snapshot">
      {INVESTMENT.items.map((it) => (
        <div key={it.id} className="flex flex-col-reverse justify-end gap-4 bg-ink p-7 md:p-9">
          <dt className="text-sm text-stone-300">{it.label}</dt>
          <dd className="font-display text-3xl font-bold text-gold md:text-4xl" data-testid={`investment-${it.id}`}>
            {it.value}{it.note && <span className="ml-2 text-base font-medium text-ivory">{it.note}</span>}
          </dd>
        </div>
      ))}
    </dl>
  </div>
);
